"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppContextService = function AppContextService(HttpService, AuthService) {
  "ngInject";

  var _appContext = void 0;
  var _activeLocation = 'au';

  var getAppContext = function getAppContext() {
    return _appContext;
  };

  var setAppContext = function setAppContext(response) {
    _appContext = response;
    return _appContext;
  };

  var clearAppContext = function clearAppContext() {
    _appContext = undefined;
    return _appContext;
  };

  var getActiveLocation = function getActiveLocation() {
    return _activeLocation;
  };

  var setActiveLocation = function setActiveLocation(newLocation) {
    _activeLocation = newLocation;
    return _activeLocation;
  };

  var fetchAppContext = function fetchAppContext(successCallback, errorCallback) {
    HttpService.get("identity/userinfo", successCallback, errorCallback);
  };

  var hasAccess = function hasAccess(roles) {
    return roles && (roles.indexOf("GlobalAdmin") != -1 || roles.indexOf("Admin") != -1 || roles.indexOf("ReadOnlyAdmin") != -1 || roles.indexOf("Analytics") != -1);
  };

  var hasReadAccess = function hasReadAccess(roles) {
    return roles && roles.indexOf("ReadOnlyAdmin") != -1;
  };

  var hasGlobalAdminAccess = function hasGlobalAdminAccess(roles) {
    return roles && roles.indexOf("GlobalAdmin") != -1;
  };

  var hasPaymentsAdminAccess = function hasPaymentsAdminAccess(roles) {
    return roles && roles.indexOf("Payments") != -1;
  };

  var hasLoginAsUserAccess = function hasLoginAsUserAccess(roles) {
    return roles && roles.indexOf("LogInAsUser") != -1;
  };

  var isAdmin = function isAdmin() {
    var location = window.location.hostname.toLowerCase();
    return _env2.default.isAdmin(location);
  };

  var isAnalytics = function isAnalytics() {
    var location = window.location.hostname.toLowerCase();
    return _env2.default.isAnalytics(location);
  };

  return { getAppContext: getAppContext, fetchAppContext: fetchAppContext, setAppContext: setAppContext, clearAppContext: clearAppContext, hasAccess: hasAccess, hasReadAccess: hasReadAccess, hasGlobalAdminAccess: hasGlobalAdminAccess, hasPaymentsAdminAccess: hasPaymentsAdminAccess, hasLoginAsUserAccess: hasLoginAsUserAccess, isAnalytics: isAnalytics, isAdmin: isAdmin, getActiveLocation: getActiveLocation, setActiveLocation: setActiveLocation };
};

exports.default = AppContextService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/app-context.service.js
 **/